// extracted by mini-css-extract-plugin
var _1 = "eliH3";
export { _1 as "hint" }
